<template>
  <v-card v-if="apiLoaded">
    <v-card-title>
      <span class="text-h5">Экспорт данных подсистемы анкетирования</span>
      <a class="close" @click="$emit('close')">
        <svg
            fill="none"
            height="24"
            viewBox="0 0 24 24"
            width="24"
            xmlns="http://www.w3.org/2000/svg"
        >
          <path
              d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
              fill="#0033A0"
          />
        </svg>
      </a>
    </v-card-title>
    <v-card-text>
      <div class="rating-popup">
        <v-container>
          <v-row>
            <v-col cols="12">
              <h4>Фильтры</h4>
            </v-col>
            <v-col cols="12">
              <v-select
                  :items="getConfigIds()"
                  v-model="configId"
                  label="Конфигурация"
              ></v-select>
            </v-col>

            <v-col cols="12">
              <v-autocomplete
                  label="Регион ЦЗН"
                  :items="$cznDepartmentsByRegionList"
                  item-text="name"
                  item-value="code"
                  v-model="filterRegion"
                  @change="onRegionSelected"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12">
              <v-autocomplete
                  label="ЦЗН"
                  :items="departmentsList"
                  item-text="name"
                  item-value="id"
                  v-model="filterCzn"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12">
              <h4>Выберите формат</h4>
            </v-col>

            <v-col cols="12">
              <v-radio-group v-model="format" row>
                <v-radio label="XLSX" value="xlsx"></v-radio>
                <v-radio label="PDF" value="pdf"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </v-card-text>
    <v-card-actions style="margin-left: 32%">
      <v-btn outlined @click="$emit('close')"> отмена</v-btn>
      <v-btn color="primary" @click="submit()"> Экспорт</v-btn>
      <div
          v-if="errorText != null"
          class="error"
          style="position: fixed; bottom: 0"
      >
        Ошибка: {{ errorText }}
      </div>
    </v-card-actions>
    <LoaderDialog :show="showLoaderDialog"></LoaderDialog>
  </v-card>
</template>

<script>
import AnketService from "../../modules/ankets";
import LoaderDialog from "../elements/LoaderDialog";
import api from "@/modules/api";

export default {
  name: "AnketsExportDialog",
  components: { LoaderDialog },
  data: () => ({
    config: null,
    configId: null,
    showLoaderDialog: false,
    departmentsList: [],
    filterRegion: null,
    filterCzn: null,
    department: null,
    sortField: null,
    sortFieldOptions: [
      { value: "cznName", text: "ЦЗН" },
      { value: "regnumber", text: "Регномер" },
      { value: "email", text: "Email" },
      { value: "localDateTime", text: "Дата заполнения" },
      { value: "sessionResult", text: "Результат приема" },
    ],
    format: "xlsx",
    sessionResults: [
      ["INFO", "Информирование"],
      ["PENS", "Для пенсионеров – досрочная пенсия"],
      ["PUBL", "Общественные работы"],
      ["ORIENT", "Профессиональная ориентация"],
      ["EDU", "Профессиональное обучение"],
      ["PROB", "Профессиональные пробы"],
      ["SUPP", "Психологическая поддержка"],
      ["SELF", "Самозанятость"],
      ["ADAPT", "Социальная адаптация"],
      ["SPEC", "Специализированные программы"],
      ["TRAIN", "Стажировка"],
      ["JOB", "Трудоустройство"],
      ["MARKT", "Ярмарка вакансий"],
    ],
    errorText: null,
    apiLoaded: false,
  }),
  methods: {
    async submit() {
      this.showLoaderDialog = true;
      let cznParam = '';
      let regionParam = '';
      if (this.filterCzn) {
        cznParam = `&czn_id=${this.filterCzn}`
      } else if (this.filterRegion){
        regionParam = `&region_code=${this.filterRegion}`;
      }
      const queryParams = `?config_id=${this.configId}${regionParam}${cznParam}`;

      try {
        const response = (await api.get(`/reports/generate/anket/1${queryParams}`)).payload;
        this.downloadTaskId = response.task_id;
        await this.checkTaskStatus();
      } catch (error) {
        console.error(error);
        alert("Ошибка при генерации отчета!");
        this.showLoaderDialog = false;
        this.$emit("close");
      }
    },

    async checkTaskStatus() {
      try {
        const response = (await api.get(`/reports/status/${this.downloadTaskId}`)).payload;
        if (response.status === "SUCCESS") {
          await this.downloadFile();
        } else {
          setTimeout(this.checkTaskStatus, 2000);
        }
      } catch (error) {
        console.error("Error checking task status:", error);
        alert("Ошибка при проверке статуса задачи!");
        this.showLoaderDialog = false;
        this.$emit("close");
      }
    },

    async downloadFile() {
      try {
        const blob = (await api.get(`/reports/download/${this.downloadTaskId}`, null, "blob")).payload;
        this.$downloadBlob(blob, `Отчет по анкетам.xlsx`);
      } catch (error) {
        console.error("Error downloading file:", error);
        alert("Ошибка при скачивании файла!");
      } finally {
        this.showLoaderDialog = false;
        this.$emit("close");
      }
    },

    sortValues(values, field) {
      if (field == null) return values;
      values.sort((a, b) => (a[field] > b[field] ? 1 : -1));
      return values;
    },

    getSessionResult(code) {
      for (let entry of this.sessionResults) {
        if (entry[0] === code) return entry[1];
      }
    },

    getConfigIds() {
      //идентификаторы анкет, которые исключаем из списка для экспорта
      const excludeIds = [167682, 167679];
      return this.configs
          .filter(v => !excludeIds.includes(v.id))
          .map(v => ({
            value: v.id,
            text: `ID ${v.id}. ${v.anket.title} ${v.anket.respondent ? '[' + v.anket.respondent + ']' : ''}`,
          }));
    },

    onRegionSelected() {
      const regionObj = this.$cznDepartmentsByRegionList.find(
          (item) => item.code === this.filterRegion
      );
      this.departmentsList = regionObj ? regionObj.departments : [];
      this.filterCzn = null;
    },
  },
  async beforeMount() {
    this.configs = await AnketService.loadAnketConfigs(
        (err) => (this.errorText = err)
    );
    this.configId = this.configs[0].id;
    this.apiLoaded = true;
  },
};
</script>
